var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleFavoriteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 22C0 9.85 9.85 0 22 0s22 9.85 22 22-9.85 22-22 22S0 34.15 0 22z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.56 14a4.44 4.44 0 00-3.224 1.399c-1.782 1.865-1.78 4.863 0 6.73l7.481 7.853v0a.243.243 0 00.357 0c2.499-2.614 4.991-5.232 7.49-7.846 1.781-1.865 1.781-4.865 0-6.73a4.423 4.423 0 00-6.455 0L22 16.662 20.791 15.4A4.457 4.457 0 0017.56 14h0z",
    fill: "#fff",
    stroke: "#fff"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--favorite-filled-991121be28d0df18b9d61948507d74f9.svg";
export { SvgIconCircleFavoriteFilled as Component };